"use client";

import { useEffect } from "react";
import type { User } from "openapi/api/model";
import { setOpenReplayUserId } from "@/observability/openreplay-setup";

export const useOpenReplayIdentity = (user: User | undefined): void => {
  useEffect(() => {
    const openReplayIdentity =
      user?.email?.trim() ||
      user?.name?.trim() ||
      user?.id;

    if (!openReplayIdentity) return;
    setOpenReplayUserId(openReplayIdentity);
  }, [user?.email, user?.name, user?.id]);
};
